import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Heading, Center, Stack, Text, useDisclosure, useBreakpointValue } from '@chakra-ui/react';

import { fetchQuestionGroupById } from '../api/Api';
import { CreateGroupForm } from '../containers/CreateGroupForm';
import { QuestionGroupPreviewModal } from '../components/QuestionGroupPreviewModal';
import { StyledButton } from '../styled-components/StyledButton';
import { IQuestionGroup } from '../interfaces/Models';

interface IRouteParams {
  [key: string]: string | undefined;
  questionGroupId: string;
}

export const CreateGroupPage = () => {
  const params = useParams<IRouteParams>();
  const location = useLocation();
  const questionGroupId = params.questionGroupId;
  const searchParams = queryString.parse(location.search);
  const defaultGroupId = searchParams?.groupId as string | undefined;
  const defaultEmail = searchParams?.email as string | undefined;

  const previewQuestionsButtonSize = useBreakpointValue(["sm", "md"]);

  const [questionGroup, setQuestionGroup] = useState<IQuestionGroup>();

  useEffect(() => {
    (async () => {
      if (questionGroupId) {
        const { data: questionGroupData, hasError: fetchQuestionGroupError } = await fetchQuestionGroupById(questionGroupId);
        setQuestionGroup(questionGroupData);
      }
    })();
  }, [questionGroupId]);

  const { isOpen: isPreviewQuestionsModalOpen, onOpen: openPreviewQuestionsModal, onClose: closePreviewQuestionsModal } = useDisclosure();

  return (
    <Stack spacing={[3, 5]} align="center" pb={["20px", "40px"]}>
      <Center>
        <Heading fontSize={["2xl", "4xl"]} px="10x" pt={["30px", "40px"]}>Create Group</Heading>
      </Center>
      <Center>
        {questionGroup?.name ?
          <Heading fontSize={["1xl", "2xl"]} px="10px" textAlign="center">{questionGroup.name}</Heading>
          :
          <Heading fontSize={["1xl", "2xl"]} px="10px" textAlign="center">&nbsp;</Heading>
        }
      </Center>
      <Center maxWidth={["lg", "xl"]}>
        <Text fontSize={["md", "lg"]} px={["24px", "20px"]}>You don't need to create any prop bets questions, we've already done all of that for you. Just fill out the form and send your unique link to your friends!</Text>
      </Center>
      <Center maxWidth={["lg", "xl"]}>
        <StyledButton
          variant="ghost"
          size={previewQuestionsButtonSize}
          onClick={openPreviewQuestionsModal}
        >
          Preview Questions
        </StyledButton>
        <QuestionGroupPreviewModal
          questionGroup={questionGroup}
          isOpen={isPreviewQuestionsModalOpen}
          onOpen={openPreviewQuestionsModal}
          onClose={closePreviewQuestionsModal}
        />
      </Center>
      <CreateGroupForm
        questionGroupId={params.questionGroupId}
        questionGroupName={questionGroup?.name}
        defaultGroupId={defaultGroupId}
        defaultEmail={defaultEmail}
      />
    </Stack>
  );
};
